/**
 * @flow
 * @relayHash b1d5e081e333a393beacc91abf8573a3
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MeetingSubscriptionVariables = {||};
export type MeetingSubscriptionResponse = {|
  +meetingSubscription: ?{|
    +action: ?string,
    +users: ?$ReadOnlyArray<?number>,
    +meeting: ?{|
      +createdAt: any,
      +updatedAt: any,
      +body: string,
      +name: string,
      +receivers: {|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +lastName: string,
            +firstName: string,
            +id: string,
            +pk: ?number,
          |}
        |}>
      |},
      +createdBy: {|
        +lastName: string,
        +firstName: string,
        +id: string,
      |},
      +meetingDate: any,
      +pk: ?number,
      +id: string,
      +deleted: boolean,
      +public: boolean,
    |},
  |}
|};
export type MeetingSubscription = {|
  variables: MeetingSubscriptionVariables,
  response: MeetingSubscriptionResponse,
|};
*/

/*
subscription MeetingSubscription {
  meetingSubscription {
    action
    users
    meeting {
      createdAt
      updatedAt
      body
      name
      receivers {
        edges {
          node {
            lastName
            firstName
            id
            pk
          }
        }
      }
      createdBy {
        lastName
        firstName
        id
      }
      meetingDate
      pk
      id
      deleted
      public
    }
  }
}
*/

const node /*: ConcreteRequest*/ = (function () {
  var v0 = {
      kind: "ScalarField",
      alias: null,
      name: "lastName",
      args: null,
      storageKey: null,
    },
    v1 = {
      kind: "ScalarField",
      alias: null,
      name: "firstName",
      args: null,
      storageKey: null,
    },
    v2 = {
      kind: "ScalarField",
      alias: null,
      name: "id",
      args: null,
      storageKey: null,
    },
    v3 = {
      kind: "ScalarField",
      alias: null,
      name: "pk",
      args: null,
      storageKey: null,
    },
    v4 = [
      {
        kind: "LinkedField",
        alias: null,
        name: "meetingSubscription",
        storageKey: null,
        args: null,
        concreteType: "MeetingSubscription",
        plural: false,
        selections: [
          {
            kind: "ScalarField",
            alias: null,
            name: "action",
            args: null,
            storageKey: null,
          },
          {
            kind: "ScalarField",
            alias: null,
            name: "users",
            args: null,
            storageKey: null,
          },
          {
            kind: "LinkedField",
            alias: null,
            name: "meeting",
            storageKey: null,
            args: null,
            concreteType: "MeetingType",
            plural: false,
            selections: [
              {
                kind: "LinkedField",
                alias: null,
                name: "createdBy",
                storageKey: null,
                args: null,
                concreteType: "UserType",
                plural: false,
                selections: [v0, v1, v2],
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "createdAt",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "body",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "name",
                args: null,
                storageKey: null,
              },
              {
                kind: "LinkedField",
                alias: null,
                name: "receivers",
                storageKey: null,
                args: null,
                concreteType: "UserTypeConnection",
                plural: false,
                selections: [
                  {
                    kind: "LinkedField",
                    alias: null,
                    name: "edges",
                    storageKey: null,
                    args: null,
                    concreteType: "UserTypeEdge",
                    plural: true,
                    selections: [
                      {
                        kind: "LinkedField",
                        alias: null,
                        name: "node",
                        storageKey: null,
                        args: null,
                        concreteType: "UserType",
                        plural: false,
                        selections: [v0, v1, v2, v3],
                      },
                    ],
                  },
                ],
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "updatedAt",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "meetingDate",
                args: null,
                storageKey: null,
              },
              v3,
              v2,
              {
                kind: "ScalarField",
                alias: null,
                name: "deleted",
                args: null,
                storageKey: null,
              },
              {
                kind: "ScalarField",
                alias: null,
                name: "public",
                args: null,
                storageKey: null,
              },
            ],
          },
        ],
      },
    ];
  return {
    kind: "Request",
    operationKind: "subscription",
    name: "MeetingSubscription",
    id: null,
    text:
      "subscription MeetingSubscription {\n  meetingSubscription {\n    action\n    users\n    meeting {\n      createdAt\n      updatedAt\n      body\n      name\n      receivers {\n        edges {\n          node {\n            lastName\n            firstName\n            id\n            pk\n          }\n        }\n      }\n      createdBy {\n        lastName\n        firstName\n        id\n      }\n      meetingDate\n      pk\n      id\n      deleted\n      public\n    }\n  }\n}\n",
    metadata: {},
    fragment: {
      kind: "Fragment",
      name: "MeetingSubscription",
      type: "Subscription",
      metadata: null,
      argumentDefinitions: [],
      selections: v4,
    },
    operation: {
      kind: "Operation",
      name: "MeetingSubscription",
      argumentDefinitions: [],
      selections: v4,
    },
  };
})();
// prettier-ignore
(node/*: any*/).hash = 'b5866fbd5e240103888043c325015fff';
module.exports = node;



// WEBPACK FOOTER //
// ./src/subscriptions/__generated__/MeetingSubscription.graphql.js